import React, { useState } from "react";
import assets from "../../../../../assets/assets";
import styled from "styled-components";
import axios from "axios";
import {
  IconController,
  LottieController,
} from "../../../../Scripts/ImgController";
import { EmailHeader, useAxiosConfigGlobal } from "../../../../Config/axios";
import { apiURL } from "../../../../Config/url";
import Ripples from "react-ripples";
import HttpConfirmation from "../../HttpConfirmation";
const Wrapper = styled.div`
  .genre-selection {
    border: 1px solid #d1d5db;
    border-radius: 8px;
    margin: auto;
    padding: 8px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: 8px;
  }
  .title-selection {
    border: 1px solid #d1d5db;
    border-radius: 8px;
    margin: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .title-selection h5 {
    border-right: 1px solid #d1d5db;
  }
  .title-inactive-color {
    color: #6b7280;
  }
  .title-warning {
    cursor: pointer;
  }
  .tooltip {
    display: inline-block;
  }

  /* Tooltip text */
  .tooltip .tooltiptext {
    visibility: hidden;
    background-color: #f59e0b;
    color: #fff;
    padding: 8px;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    bottom: 35px;
    width: 340px;
    max-width: calc(100vw - 64px);
    text-align: center;
  }
  .tooltip:hover .tooltiptext {
    visibility: visible;
  }
  input[type="text"] {
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 8px;
    font-size: 12px;
    font-weight: 600;
  }
  input[type="email"] {
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 8px;
    font-size: 12px;
    font-weight: 600;
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    appearance: textfield;
    -moz-appearance: textfield;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 8px;
    font-size: 12px;
    font-weight: 600;
  }
`;
const PersonalSection = ({
  setCKPopup,
  setCKPopupType,
  setCKPopupMessage,
  isUserCanEdit,
  oneRingRulesAll,
}) => {
  const PublisherInformation = JSON.parse(
    localStorage.getItem("Current-Publisher")
  );
  const [editable, setEditable] = useState(false);
  const axiosConfig = useAxiosConfigGlobal();
  const [emailData, setEmailData] = useState(EmailHeader);

  const [phoneValue, setPhoneValue] = useState("");
  const [mailValue, setMailValue] = useState("");
  const [idNumberValue, setIdNumberValue] = useState("");

  const [phoneChanged, setPhoneChanged] = useState(false);
  const [mailChanged, setMailChanged] = useState(false);
  const [idNumberChanged, setIdNumberChanged] = useState(false);
  const [requestSent, setRequestSent] = useState(false);

  const [confirmation, setConfirmation] = useState(false);

  const attr1 = {
    field: "Утас",
    value: {
      old: PublisherInformation?.phone,
      new: phoneValue,
    },
  };
  const attr2 = {
    field: "Цахим хаяг",
    value: {
      old: PublisherInformation?.email,
      new: mailValue,
    },
  };
  const attr3 = {
    field: "Регистр",
    value: {
      old: PublisherInformation?.registration_number,
      new: idNumberValue,
    },
  };
  const cancelHandler = () => {
    setEditable(false);
    setMailValue("");
    setPhoneValue("");
    setIdNumberValue("");
    setMailChanged(false);
    setPhoneChanged(false);
    setIdNumberChanged(false);
  };
  const phoneChangeHandler = (value) => {
    setPhoneValue(value);
    setPhoneChanged(true);
  };
  const emailChangeHandler = (value) => {
    // Daily: ene email regex eer shalgahuu?
    setMailValue(value);
    setMailChanged(true);
  };
  const idNumberChangeHandler = (value) => {
    // Daily: end registriin dugaariin regex eer shalgahuu
    setIdNumberValue(value);
    setIdNumberChanged(true);
  };

  const requestHandler = async () => {
    setRequestSent(true);
    await axios
      .post(apiURL + "notifications/panel/emails", emailData, axiosConfig)
      .then((res) => {
        if (res.status === 200) {
          emailData.attributes.length = 0;
          setCKPopupType("Success");
          setCKPopupMessage("changeRequestSuccess");
          setCKPopup(true);
          setRequestSent(false);
          cancelHandler();
        }
      })
      .catch((err) => {
        setRequestSent(false);
        if (err.response.status == 401) {
          oneRingRulesAll("logout");
        }
      });
  };
  return (
    <Wrapper className="border-CK ">
      <h5 className="font-bold text-sm pb-9">Хувийн мэдээлэл</h5>
      {editable ? (
        <>
          {requestSent ? (
            <div
              className="absolute top-0 left-0 w-full h-full  rounded-xl"
              style={{ background: "#a9b7d280" }}
            >
              <div className="w-full h-full flex flex-row justify-center items-center">
                <LottieController
                  src={assets.lottie.loadingLottie}
                  className="w-32 h-32 flex flex-row justify-center"
                />
              </div>
            </div>
          ) : (
            ""
          )}
          {requestSent ? (
            ""
          ) : (
            <div className="absolute top-4 right-4 ">
              <div className="flex flex-row gap-2">
                <Ripples color="#0061FF40" during={600} className="rounded-2xl">
                  <div
                    className="cancel-button"
                    onClick={() => {
                      cancelHandler();
                    }}
                  >
                    <div className="flex flex-row justify-center items-center px-3">
                      <h5 className="text-xs font-medium py-2 pr-1">Болих</h5>
                      <IconController
                        src={assets.svg.informationCancel}
                        className="h-4 w-4"
                      />
                    </div>
                  </div>
                </Ripples>
                <Ripples color="#ffffff40" during={600} className="rounded-2xl">
                  <div
                    className="confirm-button"
                    onClick={() => {
                      emailData.attributes.length = 0;
                      if (phoneChanged || mailChanged || idNumberChanged) {
                        if (phoneChanged) {
                          emailData.attributes.push(attr1);
                        }
                        if (mailChanged) {
                          emailData.attributes.push(attr2);
                        }
                        if (idNumberChanged) {
                          emailData.attributes.push(attr3);
                        }
                        setConfirmation(true);
                      } else {
                        setCKPopupType("Info");
                        setCKPopupMessage("nothingChanged");
                        setCKPopup(true);
                      }
                    }}
                  >
                    <div className="flex flex-row justify-center items-center px-3">
                      <h5 className="text-xs font-medium py-2 pr-1">
                        Өөрчлөх хүсэлт илгээх
                      </h5>
                      <IconController
                        src={assets.svg.requestMail}
                        className="h-4 w-4"
                      />
                    </div>
                  </div>
                </Ripples>
              </div>
            </div>
          )}
          <div className="flex flex-row flex-wrap">
            <div className="w-full sm:w-1/2 pb-6 sm:pb-8 sm:pr-3">
              <h5 className="font-medium color-grey text-xs pb-2">Утас</h5>
              <input
                type="number"
                onChange={(e) => {
                  phoneChangeHandler(e.target.value);
                }}
                placeholder={PublisherInformation?.phone}
              />
            </div>
            <div className="w-full sm:w-1/2 pb-6 sm:pb-8 sm:pr-3">
              <h5 className="font-medium color-grey text-xs pb-2">
                Цахим хаяг
              </h5>
              <input
                type="email"
                onChange={(e) => {
                  emailChangeHandler(e.target.value);
                }}
                placeholder={PublisherInformation?.email}
              />
            </div>
            <div className="w-full sm:w-1/2 pb-6 sm:pb-8 sm:pr-3">
              <h5 className="font-medium color-grey text-xs pb-2">Регистр</h5>
              <input
                type="text"
                onChange={(e) => {
                  idNumberChangeHandler(e.target.value);
                }}
                placeholder={PublisherInformation?.registration_number}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="flex flex-row flex-wrap">
            <div className="w-full sm:w-1/2 pb-6 sm:pb-8 sm:pr-3">
              <h5 className="font-medium color-grey text-xs pb-2">Утас</h5>
              <h5 className="font-semibold text-xs">
                {PublisherInformation?.phone}
              </h5>
            </div>
            <div className="w-full sm:w-1/2 pb-6 sm:pb-8 sm:pr-3">
              <h5 className="font-medium color-grey text-xs pb-2">
                Цахим хаяг
              </h5>
              <h5 className="font-semibold text-xs">
                {PublisherInformation?.email}
              </h5>
            </div>
            <div className="w-full sm:w-1/2 pb-6 sm:pb-8 sm:pr-3">
              <h5 className="font-medium color-grey text-xs pb-2">Регистр</h5>
              <h5 className="font-semibold text-xs">
                {PublisherInformation?.registration_number}
              </h5>
            </div>
          </div>
          {isUserCanEdit ? (
            <div className="edit-button">
              <Ripples color="#0061FF40" during={600} className="rounded-2xl">
                <div
                  className="flex flex-row justify-center items-center px-3"
                  onClick={() => {
                    setEditable(true);
                  }}
                >
                  <h5 className="text-xs font-medium py-2 pr-1">Засах</h5>
                  <IconController
                    src={assets.svg.editIcon}
                    className="h-4 w-4"
                  />
                </div>
              </Ripples>
            </div>
          ) : (
            ""
          )}
        </>
      )}
      {confirmation ? (
        <HttpConfirmation
          yesFunc={requestHandler}
          data={emailData}
          noFunc={setConfirmation}
        />
      ) : (
        ""
      )}
    </Wrapper>
  );
};

export default PersonalSection;
